import React, { useEffect } from "react";
import ServiceCard from "../../../../shared/components/ServiceCard";
import { Link, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { getProfileAction } from "../../../../store/actions/user.actions";
import { fetchAnalytics } from "../../../../store/slices/dashboardSlice";
import PaymentIcon from "../../../../assets/icon/payment.svg";
import ReadyIcon from "../../../../assets/icon/ready.svg";
import DeliveryIcon from "../../../../assets/icon/delivery.svg";
import ReworkIcon from "../../../../assets/icon/rework.svg";
import DraftIcon from "../../../../assets/icon/draft.svg";
import { slugify } from "../../../../utils/commonFunctions";
import { clearOrders } from "../../../../store/slices/ordersSlice";

export default function Home() {
  const { services } = useSelector((state) => state.service);
  const { analytics } = useSelector((state) => state.dashboard);

  const dispatch = useDispatch();
  const navigate = useNavigate();

  const { profile } = useSelector((state) => state.user);

  useEffect(() => {
    dispatch(getProfileAction());
    dispatch(fetchAnalytics());
  }, [dispatch]);

  const orderData = [
    {
      id: 1,
      // icon: "pi pi-money-bill",
      icon: PaymentIcon,
      title: "Awaiting payment",
      countKey: "awaitingPayment",
    },
    {
      id: 2,
      // icon: "pi pi-clock",
      icon: ReadyIcon,
      title: "Getting ready",
      countKey: "ready",
    },
    {
      id: 3,
      // icon: "pi pi-check-circle",
      icon: DeliveryIcon,
      title: "Order delivered",
      countKey: "orderDelivered",
    },
    {
      id: 4,
      // icon: "pi pi-refresh",
      icon: ReworkIcon,
      title: "Rework requested",
      countKey: "rework",
    },
    {
      id: 5,
      // icon: "pi pi-pencil",
      icon: DraftIcon,
      title: "In draft",
      countKey: "draft"
    },
  ];

  return (
    <div className="container">
      <h2 className="text-3xl">Welcome, {profile?.fullName}</h2>

      {/* Order Overview Section */}
      <div className="card shadow-2 border-round-xl p-5 mb-4">
        <h3 className="mt-0">Order Overview</h3>
        <div className="grid mt-3">
          {orderData.map((order) => (
            <div
              key={order.id}
              className="col-12 sm:col-6 lg:col cursor-pointer"
              onClick={() => {
                navigate(`/dashboard/my-orders/${slugify(order.title)}`)
                dispatch(clearOrders());
              }}
            >
              <div className="card bg-light-primary h-full shadow-1 p-4 border-round">
                <div className="flex align-items-center gap-3 mb-3">
                  <img src={order.icon} className={`text-pink-500 text-2xl`} />
                  <div className="text-4xl font-bold mb-1">
                    {analytics?.[order.countKey]}
                  </div>
                </div>

                <div className="text-center flex gap-3 align-items-center justify-content-between">
                  <div className="text-base">{order.title}</div>
                  <i className="pi pi-arrow-right font-bold"></i>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* recent acivity */}
      {/* <div className="card shadow-2 border-round-xl p-5 mb-4">
        <h3 className="mt-0">Recent Activity</h3>
        <div className="grid mt-3">
          <div className="lg:col-3">
            <img src={AfterImg} className="w-full border-round-lg" alt="" />
          </div>
          <div className="lg:col-6">
            <div className="grid">
              <div className="md:col-6">
                <h4 className="m-0">Project Type</h4>
                <p className="m-0 mt-2">Virtual Staging</p>
              </div>
              <div className="md:col-6">
                <h4 className="m-0">Quantity</h4>
                <p className="m-0 mt-2">3 images</p>
              </div>
              <div className="md:col-6">
                <h4 className="m-0">Project Name</h4>
                <p className="m-0 mt-2">Home 13</p>
              </div>
            </div>
          </div>
          <div className="lg:col-3 flex flex-column justify-content-between align-items-end">
            <p className="primary-color bg-light-primary p-3 px-4 border-round-3xl m-0">
              In Draft
            </p>
            <PrimaryButton
              label="Review and place order"
              onClick={() => navigate("/orders/place-order")}
            />
          </div>
        </div>
      </div> */}

      {/* new order place */}
      <div className="card shadow-2 border-round-xl p-5 mb-4">
        <div className="flex mb-3 align-items-center justify-content-between">
          <h3 className="m-0">Place a new order</h3>
          <Link to="" className="primary-color no-underline">
            View all services
          </Link>
        </div>
        <div className="grid mt-3">
          {services?.map((service, index) => {
            return (
              <ServiceCard
                key={index}
                extraClass="col-12 lg:col-4"
                hasBeforeAfterImage={service?.hasBeforeAfterImages}
                AfterImg={service?.primaryAfterImage}
                BeforeImg={service?.primaryBeforeImage}
                singleImage={service?.primarySingleImage}
                title={service?.serviceName}
                showButton={false}
                style={{ height: "250px" }}
                onClick={() => navigate("/orders/place-order/" + service._id)}
              />
            );
          })}
        </div>
      </div>
    </div>
  );
}
